import { render, staticRenderFns } from "./HolidayList.vue?vue&type=template&id=5942a05c&"
import script from "./HolidayList.vue?vue&type=script&lang=js&"
export * from "./HolidayList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports